// Centralized configuration for RotationListReport
const rotationListReportConfig = {
  reportKey: "rotation_list_report_column_visibility",

  tableTemplate: [
    { field: "rotation_list_main_id", headerName: "Rotation List ID" },
    { field: "associate_id", headerName: "Associate ID11111" },
    { field: "asso_name", headerName: "Associate Name11111" },
    { field: "grade", headerName: "Grade" },
    { field: "skill", headerName: "Skill" },
    { field: "primary_skill", headerName: "Primary Skill" },
    { field: "detailed_skill", headerName: "Detailed Skill" },
    { field: "skill_family", headerName: "Skill Family" },
    { field: "asso_city", headerName: "City" },
    { field: "country", headerName: "Country" },
    { field: "region", headerName: "Region" },
    { field: "pdl", headerName: "PDL" },
    { field: "rotation_eligible", headerName: "Rotation Eligible" },
    { field: "to_be_rotated_yes_no", headerName: "To Be Rotated" },
    { field: "planned_date_of_rotation", headerName: "Planned Date Of Rotation" },
    { field: "month", headerName: "Month" },
    { field: "timeframe", headerName: "Timeframe" },
    { field: "replacement_reqd_yes_no", headerName: "Replacement Required" },
    { field: "replacement_grade", headerName: "Replacement Grade" },
    { field: "cross_skilling_required_yes_no", headerName: "Cross Skilling Required" },
    { field: "comments", headerName: "Comments" },
    { field: "project_ageing", headerName: "Project Ageing" },
    { field: "account_ageing", headerName: "Account Ageing" },
    { field: "parent_customer_ageing", headerName: "Parent Customer Ageing" },
    { field: "proj_id", headerName: "Project ID" },
    { field: "proj_name", headerName: "Project Name" },
    { field: "cust_id", headerName: "Customer ID" },
    { field: "cust_name", headerName: "Customer Name" },
    { field: "parent_cust_id", headerName: "Parent Customer ID" },
    { field: "parent_cust_name", headerName: "Parent Customer Name" },
    { field: "market", headerName: "Market" },
    { field: "market_unit", headerName: "Market Unit" },
    { field: "business_unit", headerName: "Business Unit" },
    { field: "pm_id", headerName: "PM ID" },
    { field: "pm_name", headerName: "PM Name" },
    { field: "allo_start", headerName: "Allocation Start" },
    { field: "alloc_end", headerName: "Allocation End" },
    { field: "proj_bill_type", headerName: "Project Bill Type" },
    { field: "asso_billability", headerName: "Associate Billability" },
    { field: "alloc_", headerName: "Alloc %" },
    { field: "billability_", headerName: "Billability %" },
    { field: "total_alloc_", headerName: "Total Alloc %" },
    { field: "on_off", headerName: "On/Offshore" },
    { field: "lob", headerName: "LOB" },
    { field: "track", headerName: "Track" },
    { field: "department_code", headerName: "Department Code" },
    { field: "sub_department", headerName: "Sub Department" },
    { field: "allocation_status", headerName: "Allocation Status" },
    { field: "designation", headerName: "Designation" },
    { field: "competency", headerName: "Competency" },
    { field: "sub_vertical", headerName: "Sub Vertical" },
    { field: "visa_status", headerName: "Visa Status" },
    { field: "visa_type", headerName: "Visa Type" },
    { field: "solution_group", headerName: "Solution Group" },
    { field: "project_region", headerName: "Project Region" },
    { field: "last_updated_date", headerName: "Last Updated Date" },
    { field: "report_extraction_date", headerName: "Report Extraction Date" }
  ],

  filterTemplate: [
    { field: "rotation_eligible", headerName: "Rotation Eligible" },
    { field: "market", headerName: "Market" },
    { field: "region", headerName: "Region" },
    { field: "asso_city", headerName: "City" },
    { field: "proj_bill_type", headerName: "Project Bill Type" },
    { field: "primary_skill", headerName: "Primary Skill" },
    { field: "grade", headerName: "Grade" },
    { field: "pdl", headerName: "PDL Name" }
  ],

  editableColumns: [
    { field: "Associate ID", headerName: "Associate ID", apiField: "associate_id" },
    { field: "Associate Name", headerName: "Associate Name", apiField: "asso_name" },
    { field: "Talent Plan", headerName: "Talent Plan", apiField: "talent_plan" },
    { field: "Replacement Plan", headerName: "Replacement Plan", apiField: "replacement_plan" },
    { field: "Replacement GenC AssoId", headerName: "Replacement GenC AssoId", apiField: "replacement_genc_asso_id" },
    { field: "Replacement Asso. Name", headerName: "Replacement Asso. Name", apiField: "replacement_associate_name" },
    { field: "Replacement Asso. Grade", headerName: "Replacement Asso. Grade", apiField: "replacement_associate_grade" },
    { field: "Rotation Planned Date", headerName: "Rotation Planned Date", apiField: "planned_date_of_rotation" },
    { field: "Rotation Month", headerName: "Rotation Month", apiField: "plan_for_rotation" },
    { field: "Target Account", headerName: "Target Account", apiField: "target_account" },
    { field: "Skill Development Plan", headerName: "Skill Development Plan", apiField: "skill_development_plan" },
    { field: "Replacement SO ID", headerName: "Replacement SO ID", apiField: "replacement_so_id" },
    { field: "Remarks", headerName: "Remarks", apiField: "remarks" },
    { field: "Approved by Leadership(not rotatable)", headerName: "Approved by Leadership(not rotatable)", apiField: "approved_by_leadership_not_rotatable" },
  ],

  // Audit columns for audit modal (exported so page can use them)
  auditColumns: [
    { field: "Associate ID", headerName: "Associate ID" },
    // { field: "Associate Name", headerName: "Associate Name" },
    { field: "Talent Plan", headerName: "Talent Plan" },
    { field: "Replacement Plan", headerName: "Replacement Plan" },
    { field: "Replacement GenC AssoId", headerName: "Replacement GenC AssoId" },
    // { field: "Replacement Asso. Name", headerName: "Replacement Asso. Name" },
    // { field: "Replacement Asso. Grade", headerName: "Replacement Asso. Grade" },
    { field: "Rotation Planned Date", headerName: "Rotation Planned Date" },
    { field: "Rotation Month", headerName: "Rotation Month" },
    { field: "Target Account", headerName: "Target Account" },
    { field: "Skill Development Plan", headerName: "Skill Development Plan" },
    { field: "Replacement SO ID", headerName: "Replacement SO ID" },
    { field: "Remarks", headerName: "Remarks" },
    { field: "Approved by Leadership(not rotatable)", headerName: "Approved by Leadership(not rotatable)" },
    { field: "Last Updated By ID", headerName: "Last Updated By ID" },
    { field: "Last Updated By Name", headerName: "Last Updated By Name" },
    { field: "Last Updated On", headerName: "Last Updated On" },
  ]

};

export default rotationListReportConfig;
